<template>
  <v-card :color="color" class="note" elevation="4">
    <v-card-title>
      {{ title }}
    </v-card-title>
    <v-card-text>
      {{ content }}
    </v-card-text>
    <v-card-actions>
      <v-btn icon @click="deleteNote">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    title: String,
    content: String,
    color: String,
  },
  methods: {
    deleteNote() {
      this.$emit('delete');
    },
  },
};
</script>

<style scoped>
.note {
  margin: 10px;
  min-width: 200px;
  padding: 16px;
  border-radius: 8px;
  position: relative;
}

.v-btn {
  position: absolute;
  top: 8px;
  right: 8px;
}
</style>
